import { createAsyncThunk, createSlice, PayloadAction } from '@reduxjs/toolkit'
import axios from 'axios'
import Cookies from 'universal-cookie/es6'
import { IUser, IUserState } from '../../interfaces'
import { RootState } from '../store'

const initialState: IUserState = {
    id: null,
    username: null,
    email: null,
    avatar: null,
    status: 'idle'
}

export const fetchUser = createAsyncThunk('user/fetch', async (token) => {
    let user = await axios.get('/api/users/@me', { headers: { 'authorization': `Bearer ${token}` } })
        .then(res => res.data)
    if(user) {
        let cookies = new Cookies();
        cookies.set('token', token);
    }
    return user;
})

export const userSlice = createSlice({
    name: 'user',
    initialState,
    reducers: {
      setUser: (state, action: PayloadAction<IUser>) => {
          state = {
              ...state, 
              ...action.payload
          }
      },
      getUser: (state) => {
          return state;
      },
      logoutUser(state) {
        localStorage.removeItem('token')
        return initialState;
      }
    },
    extraReducers: (builder) => {
        builder.addCase(fetchUser.pending, (state, action) => {
            console.log(`**FETCHING**`)
            state.status = 'fetching'
            return state;
        })
        .addCase(fetchUser.rejected, (state) => {
            state = {
                ...state,
                status: 'error'
            }
            return state;
        })
        .addCase(fetchUser.fulfilled, (state, action) => {
            console.log(`**FETCHED**`)
            state = {
                ...state,
                status: 'idle',
                ...action.payload
            }
            return state;
        })
    }
  })
  

export const { setUser, getUser, logoutUser } = userSlice.actions

export const selectUser = (state: RootState) => state.user

export default userSlice.reducer